export type tCaseComponentType = 'shelfCNC' | 'shelfCNCHard' |  'shelf' | 'drawer' | 'separator' | 'drawerSeparator' | 'separatorT' |'accessory' | 'shield' | 'other';
export type tCaseModel = 'TC-1095' | 'TC-1995' | 'TC-1995-2' | 'TC-1947' | 'AMH-TC' | 'AMH-TC-EL' | 'HARD-1000' | 'HARD-2000';
export type tBlenderCaseModel = 'tc_1995' | 'tc_1095' | 'hard_1000' | 'tc_1947' | 'hard_2000' | 'amh_tc' | 'amh_tc_el' | 'tc_1995_2';

export const blenderCaseModels: tBlenderCaseModel[] = [ 'tc_1995', 'tc_1095', 'hard_1000', 'tc_1947', 'hard_2000' | 'amh_tc', 'amh_tc_el', 'tc_1995_2' ];
export const caseComponents: Exclude<tCaseComponentType, 'other'>[] = [ 'shelfCNC', 'shelfCNCHard', 'shelf', 'drawer', 'separator', 'drawerSeparator', 'separatorT', 'accessory', 'shield' ];
export type tParentAccessory =  'shelf' | 'shield';

export interface iCaseComponentsLibItem {
    id: string,
    name: string,
    type: tCaseComponentType,
    caseModels: Array<tCaseModel>,
    blenderName: string,
    image: string,
    xmlId: string,
    noVisible?: boolean,
}

export interface iCaseComponentsResultItem {
    id: string,
    // prototypeId - короткое blenderName элемента библиотеки
    prototypeId: string,
    indexPositionY?: number,
    isLeft: boolean,
    // indexPositionX - позиция по хдля аксессуаров
    indexPositionX?: number,
    isDefaultHolder?: boolean,
    //idGroup - индекс для группы полок чпу
    idGroup?: number,
}

export interface iCaseComponentsResultItemGroup extends iCaseComponentsResultItem{
    count: number,
}

export interface iDrawerSeparator {
    id: string,
    name: string,
    type: tCaseComponentType,
    applicableDrawerIds: Array<string>,
    blenderName: string,
    image: string,
    xmlId: string,
}

export interface iDrawerSeparatorResultItem {
    prototypeId: string, // id drawer separator
    drawerPrototypeId: string, // id модели родительского ящика
    count: number, //сколько штук
}

export type tCaseComponentsLib = Array<iCaseComponentsLibItem>
export type tDrawerSeparatorsLib = Array<iDrawerSeparator>

export interface iItemFromApi {
    name: string,
    externalId:	string,
    xmlId: string,
    price: string,
    sort: string,
    previewPicture:	string | null,
    upperSort: number,
    parentId: string | null,
    preset: string | null,
    weight: string,
    width: string,
    height: string,
    depth: string
}

export type tItemsFromApi = Array<iItemFromApi>;
